import { OpenAI } from "openai";
import { apiCall } from "./store-util";
import dayjs from "dayjs";
import { CharacterSheet } from "../Index/LLM-Gaming/CharacterSheetComponent";

const openai = new OpenAI({
    organization: "org-rON0ehkoSmFqPXWcLUauDput",
    apiKey: process.env.REACT_APP_OPENAI_APIKEY,
    dangerouslyAllowBrowser: true
});

let allMessages;

export const createNewThread = async () => {
    return await openai.beta.threads.create();
}

const handleRun = async (threadId, run) => {
    let action = null;

    while (run.status === "queued" || run.status === "in_progress") {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        run = await openai.beta.threads.runs.retrieve(threadId, run.id);
    }

    if (run.status === "requires_action") {
         for (const tool of run?.required_action?.submit_tool_outputs?.tool_calls) {
            action = tool?.function;
            if (tool?.function?.name === "health_decrease"
                || tool?.function?.name === "health_increase"
                || tool?.function?.name === "change_scene"
                || tool?.function?.name === "give_item"
            ) {
                await fulfillToxicAction(threadId, run, ["success"]).then((res) => {
                    allMessages = res.messages;
                });
            }
        };
    } else if (run.status === "completed") {
        allMessages = await openai.beta.threads.messages.list(threadId);
    }

    return {
        messages: allMessages,
        action: action,
        run: run
    };
};

export const queryToxicDM = async (threadId, query, system = false) => {
    await openai.beta.threads.messages.create(threadId, {
        role: system ? 'assistant' : 'user',
        content: query
    });

    const run = await openai.beta.threads.runs.create(threadId, { assistant_id: "asst_CHXcvzafeiHEFgpLAFuofkQL" });

    return await handleRun(threadId, run);
}

export const fulfillToxicAction = async (threadId, run, outputs: any[]) => {
    const toolOutputs = run?.required_action?.submit_tool_outputs?.tool_calls.map((tool, i) => {
        // if (tool?.function?.name === "ability_check") {
            return {
                tool_call_id: tool?.id,
                output: outputs[i],
            };
        // }
    });

    return await openai.beta.threads.runs.submitToolOutputsAndPoll(threadId, run.id, { tool_outputs: toolOutputs })
        .then(async (res) => {
            return await handleRun(threadId, res);
        });
};

export const getDailyWisdom = () => {
    return apiCall("get-daily-wisdom").then((response: any) => {
        const res = JSON.parse(response)[0];
        
        return res.wisdom;
    });
}